/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj } from '@/utils/util'
import { deleteAction, getAction, downFile, getFileAccessHttpUrl, postFormAction } from '@/api/manage'
import Vue from 'vue'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import store from '@/store'
import { Modal } from 'ant-design-vue'
import { getLanguageField } from '@/utils/langUtils'

export const JeecgListMixin = {
  data(){
    return {
      //token header
      // tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      /* 数据源 */
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['30', '50', '100'],
        showTotal: ( total, range ) => {
          return range[ 0 ] + '-' + range[ 1 ] + ' ' + this.$t('tip.total') + total + this.$t('tip.article')
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* 高级查询条件生效状态 */
      superQueryFlag: false,
      /* 高级查询条件 */
      superQueryParams: '',
      /** 高级查询拼接方式 */
      superQueryMatchType: 'and',
      mainLangItems: []
    }
  },
  computed: {
    scroll(){
      var width = window.innerWidth
      let $antTable = window.document.getElementsByClassName('ant-row')
      if ($antTable[ 0 ]) {
        width = $antTable[ 0 ].clientWidth
      }
      return {
        // x:'max-content',
        x: width,
        y: window.innerHeight / 2
      }
    },
    innerHeight(){
      var innerHeight = window.innerHeight
      return innerHeight
    },
    tokenHeader(){
      let head = { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) }
      let tenantid = Vue.ls.get(TENANT_ID)
      if (tenantid) {
        head[ 'tenant-id' ] = tenantid
      }
      return head
    }
  },
  created(){
    if (!this.disableMixinCreated) {
      this.loadData()
      //初始化字典配置 在自己页面定义
      this.initDictConfig()
    }
    this.$bus.$on('changeLangGetList', () => {
      this.loadData(1)
    })
    // this.getLangItem()
    this.$nextTick(() => {
      this.$bus.$emit('mainlanguageLists', {})
    })
  },
  methods: {
    //同步
    /*handleSync(record){
      let syncUrl = "/efsc/efsWmOperation/syncOrder"
      postFormAction(syncUrl, {operCode: record.operCode}).then((res) => {
          if (res.success) {
              this.$message.success(res.message);
              this.onClearSelected();
          } else {
              this.$message.warning(res.message);
          }
      }).finally(() => {
          this.loadData();
          this.loading = false;
      });
    },*/
    whetherLang( dataIndex ){
      let flag = false
      this.mainLangItems.map(item => {
        if (item.relEntityAttribute == dataIndex) {
          flag = true
        }
      })
      return flag
    },
    // 获取多语言字段 relEntityAttribute
    getLangItem(){
      this.mainTable && getLanguageField(this.mainTable).then(res => {
        this.mainLangItems = res.data
      })
    },
    loadData( arg ){
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      var params = this.getQueryParams()//查询条件
      this.loading = true
      getAction(this.url.list, params).then(( res ) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          this.dataSource = res.result.records || res.result
          let languageList = res.languageList
          let sysLanguageList = []
          // 列表多语言
          if (languageList && languageList.length) {
            console.log('%c [ this.languageList ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.languageList)
            this.dataSource.map(item => {
              let secondLanguage = []
              languageList.map(sItem => {
                if (item.id == sItem.relBizId) {
                  if (sItem[ 'buffer1' ] == 'Y') {
                    sysLanguageList.push(sItem)
                    if (sItem[ 'langType' ] == this.$ls.get('language', 'zh-cn')) {
                      item[ sItem[ 'relEntityAttribute' ] ] = sItem[ 'langText' ]
                    } else {
                      let secondLanguages = JSON.parse(this.$ls.get('secondLanguage')) || []
                      secondLanguages && secondLanguages.length && secondLanguages.map(ssItem => {
                        if (ssItem == sItem.langType) {
                          secondLanguage.push(sItem)
                        }
                      })
                    }
                  }
                }
              })
              this.languageList = sysLanguageList
              item[ 'secondLanguage' ] = secondLanguage
              item[ 'sysLanguageList' ] = sysLanguageList
            })
          }
          console.log('%c [ this.dataSource ]', 'font-size:13px; background:pink; color:#bf2c9f;', this.dataSource)
          if (res.result.total) {
            this.ipagination.total = res.result.total
          } else {
            this.ipagination.total = 0
          }
          //update-end---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    initDictConfig(){

    },
    handleSuperQuery( params, matchType ){
      //高级查询方法
      if (!params) {
        this.superQueryParams = ''
        this.superQueryFlag = false
      } else {
        this.superQueryFlag = true
        this.superQueryParams = JSON.stringify(params)
        this.superQueryMatchType = matchType
      }
      this.loadData(1)
    },
    getQueryParams(){
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp[ 'superQueryParams' ] = encodeURI(this.superQueryParams)
        sqp[ 'superQueryMatchType' ] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      param.field = this.getQueryField()
      param.langType = this.$ls.get('language')
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    getQueryField(){
      //TODO 字段权限控制
      var str = 'id,'
      this.columns.forEach(function( value ){
        str += ',' + value.dataIndex
      })
      return str
    },
    onSelectChange( selectedRowKeys, selectionRows ){
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    onClearSelected(){
      this.selectedRowKeys = []
      this.selectionRows = []
    },
    searchQuery(){
      this.loadData(1)
    },
    superQuery(){
      this.$refs.superQueryModal.show()
    },
    searchReset(){
      this.queryParam = {}
      this.loadData(1)
    },
    batchDel(){
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[ a ] + ','
        }
        var that = this
        this.$confirm({
          title: this.$t('tip.confirmDeletion'),
          content: this.$t('tip.deleteTheSelectedData'),
          onOk(){
            that.loading = true
            deleteAction(that.url.deleteBatch, { ids: ids }).then(( res ) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.loading = false
            })
          }
        })
      }
    },
    handleDelete( id ){
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { id: id }).then(( res ) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData()
          this.$refs.baseTable && this.$refs.baseTable.refresh()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleEdit( record ){
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('button.edit')
      this.$refs.modalForm.disableSubmit = false
      // 把列表的多语言传给弹框的主表，用来显示次语言和数据反显
      let langReturn = []
      this.languageList && this.languageList.length && this.languageList.map(item => {
        if (item.relBizId == record.id) {
          langReturn.push(item)
        }
      })
      this.$nextTick(() => {
        this.$bus.$emit('mainlanguageLists', langReturn)
      })
    },
    handleCopy( record ){
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.copy = true
      this.$refs.modalForm.model.id = ''
      this.$refs.modalForm.model.isCopy = true
      // this.$refs.modalForm.model.operCode = ''
      this.$refs.modalForm.model.createBy = ''
      this.$refs.modalForm.model.createBy_dictText = ''
      this.$refs.modalForm.model.createTime = ''
      this.$refs.modalForm.title = this.$t('button.addByReference')
      this.$refs.modalForm.disableSubmit = false
    },
    handleAdd(){
      let modalForm = this.$refs.modalForm
      modalForm.add()
      modalForm.title = this.$t('button.add')
      modalForm.disableSubmit = false
      modalForm?.setCompanyCode && modalForm.setCompanyCode()
      this.$nextTick(() => {
        this.$bus.$emit('mainlanguageLists', [])
      })
    },
    handleSubmit( code ){ // 提交
      if (!this.url.submit) {
        this.$message.error('请设置url.submit属性!')
        return
      }
      postFormAction(this.url.submit, { operCode: code })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.onClearSelected()
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loadData()
          this.loading = false
        })
    },
    handleReserve( code ){ // 冲销
      if (!this.url.reserve) {
        this.$message.error('请设置url.reserve属性!')
        return
      }
      postFormAction(this.url.reserve, { operCode: code })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
            this.onClearSelected()
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange( pagination, filters, sorter ){
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order? 'asc': 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    // 给popup查询使用(查询区域不支持回填多个字段，限制只返回一个字段)
    getPopupField( fields ){
      return fields.split(',')[ 0 ]
    },
    modalFormOk(){
      // 新增/修改 成功时，重载列表
      this.loadData()
      //清空列表选中
      this.onClearSelected()
      this.$refs.baseTable && this.$refs.baseTable.refresh()
    },
    handleDetail( record ){
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.$t('button.details')
      this.$refs.modalForm.disableSubmit = true
      // 把列表的多语言传给弹框的主表，用来显示次语言和数据反显
      let langReturn = []
      this.languageList && this.languageList.length && this.languageList.map(item => {
        if (item.relBizId == record.id) {
          langReturn.push(item)
        }
      })
      console.log('%c [ langReturn ]', 'font-size:13px; background:pink; color:#bf2c9f;', langReturn)
      this.$nextTick(() => {
        this.$bus.$emit('mainlanguageLists', langReturn)
      })
    },
    handleDetailB( record ){
      this.$refs.modalFormDetail.edit(record)
      this.$refs.modalFormDetail.title = this.$t('button.details')
      this.$refs.modalFormDetail.disableSubmit = true
      // 把列表的多语言传给弹框的主表，用来显示次语言和数据反显
      let langReturn = []
      this.languageList && this.languageList.length && this.languageList.map(item => {
        if (item.relBizId == record.id) {
          langReturn.push(item)
        }
      })
      this.$nextTick(() => {
        this.$bus.$emit('mainlanguageLists', langReturn)
      })
    },
    /* 导出 */
    handleExportXls2(){
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()))
      let url = `${ window._CONFIG[ 'domianURL' ] }/${ this.url.exportXlsUrl }?paramsStr=${ paramsStr }`
      window.location.href = url
    },
    handleExportXls( fileName ){
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件'
      }
      let param = { ...this.queryParam }
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param[ 'selections' ] = this.selectedRowKeys.join(',')
      }
      downFile(this.url.exportXlsUrl, param).then(( data ) => {
        if (!data) {
          this.$message.warning(this.$t('tip.fileDownloadFailed'))
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },
    /* 导入 */
    handleImportExcel( info ){
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 201) {
            let { message, result: { msg, fileUrl, fileName } } = info.file.response
            let href = window._CONFIG[ 'domianURL' ] + fileUrl
            this.$warning({
              title: message,
              content: (
                `<div>
                  <span>{msg}</span><br/>
                  <span>具体详情请 <a href={href} target="_blank" download={fileName}>点击下载</a> </span>
                </div>`
              )
            })
          } else {
            this.$message.success(info.file.response.message || `${ info.file.name } 文件上传成功`)
          }
          this.loadData()
        } else {
          this.$message.error(`${ info.file.name } ${ info.file.response.message }.`)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败: ${ info.file.msg } `)
      }
    },
    /* 图片预览 */
    getImgView( text ){
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      return getFileAccessHttpUrl(text)
    },
    /* 文件下载 */
    uploadFile( text ){
      if (!text) {
        this.$message.warning('未知的文件')
        return
      }
      if (text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','))
      }
      let url = getFileAccessHttpUrl(text)
      window.open(url)
    }
  }
}